import {
  states,
  countries,
  US,
  Mexico,
  Canada,
  expandedStates,
} from "../../../../constants/data";
import Styles from "../editScreenStyles.module.css";

function LocationEdit({
  fields,
  utilities,
  updateClicked,
  cancelClicked
}) {

  const {
    createEditScreenInput,
    createCustomLabelSelect,
  } = utilities;

  return (
    <div>
      <div className={Styles.title}>Incident Location</div>
      <div className={Styles.column}>
        <div className={Styles.row}>
          {createEditScreenInput(fields.whereAddress, "50%", Styles.input, Styles.label)}
          {createEditScreenInput(fields.whereCity, "50%", Styles.input, Styles.label)}
        </div>
        <div className={Styles.row}>
          {fields.whereCountry.value === US.name ? (
            <>
            {createCustomLabelSelect(
              fields.whereState,
              states,
              Styles.select,
              Styles.label,
              { placeholder: "Select A State"}
            )} {
            }
            </>
          ) : (
            <>
            {fields.whereCountry.value === Mexico.name
            ? createEditScreenInput(
              fields.whereState, 
              "50%", 
              Styles.input,
              Styles.label,
              )
            : createCustomLabelSelect(
                fields.whereState,
                expandedStates
                  .filter((state) => state.country.code === Canada.code)
                  .map((state) => state.state),
                Styles.select,
                Styles.label,
                { placeholder: "Select a Province" }
              )
            }
            </>
          )}
          {createEditScreenInput(fields.whereCounty, "50%", Styles.input, Styles.label)}
        </div> 
       
         <div className={Styles.row}>
         {createEditScreenInput(fields.whereZipcode, "50%", Styles.input, Styles.label)}
          {createCustomLabelSelect(
            fields.whereCountry,
            countries.map((country) => country.name),
            Styles.select,
            Styles.label
          )}
        </div>
        <div className={Styles.buttons}>
          <button
            type="button"
            className={Styles.button}
            onClick={cancelClicked}
          >
            Cancel
          </button>
          <button
            type="button"
            className={Styles.button}
            onClick={updateClicked}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default LocationEdit;
